import api from "../../../services/api";

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isLoadingBooks: false,
        availableBooks: [],
        courseBooks: [],
    },
    mutations: {
        SET_LOADING_STATUS(state, status) {
            state.isLoading = status === null ? !state.isLoading : status;
        },
        SET_LOADING_BOOKS_STATUS(state, status) {
            state.isLoadingBooks = status === null ? !state.isLoadingBooks : status;
        },
        SET_AVAILABLE_BOOKS(state, books) {
            state.availableBooks = books;
        },
        SET_COURSE_BOOKS(state, books) {
            state.courseBooks = books;
        },
        ADD_COURSE_BOOK(state, book) {
            const existingIndex = state.courseBooks.findIndex(b => b.cb_id === book.cb_id);
            if (existingIndex === -1) {
                state.courseBooks.push(book);
            }
        },
        REMOVE_COURSE_BOOK(state, bookId) {
            state.courseBooks = state.courseBooks.filter(book => book.book.book_id !== bookId);
        },
        UPDATE_COURSE_BOOKS_ORDER(state, books) {
            state.courseBooks = books;
        },
    },
    getters: {
        isLoading(state) {
            return state.isLoading;
        },
        isLoadingBooks(state) {
            return state.isLoadingBooks;
        },
        availableBooks(state) {
            return state.availableBooks;
        },
        courseBooks(state) {
            return state.courseBooks;
        },
    },
    actions: {
        async fetchAvailableBooks(context) {
            context.commit("SET_LOADING_BOOKS_STATUS", true);

            try {
                const { data } = await api.get("/v1/books", {});
                context.commit("SET_AVAILABLE_BOOKS", data.data || []);
                return data.data || [];
            } catch (error) {
                console.error("fetchAvailableBooks:", error);
                throw error;
            } finally {
                context.commit("SET_LOADING_BOOKS_STATUS", false);
            }
        },

        async fetchCourseBooks(context, courseId) {
            context.commit("SET_LOADING_STATUS", true);

            try {
                const { data } = await api.get(`/v1/courses/${courseId}/books`);
                context.commit("SET_COURSE_BOOKS", data.data || []);
                return data.data || [];
            } catch (error) {
                console.error("fetchCourseBooks:", error);
                throw error;
            } finally {
                context.commit("SET_LOADING_STATUS", false);
            }
        },

        async addBooksToCourse(context, { courseId, bookIds }) {
            context.commit("SET_LOADING_STATUS", true);

            try {
                const { data } = await api.post(`/v1/courses/${courseId}/books`, {
                    book_ids: bookIds,
                });
                return data;
            } catch (error) {
                console.error("addBooksToCourse:", error);
                throw error;
            } finally {
                context.commit("SET_LOADING_STATUS", false);
            }
        },

        async removeBookFromCourse(context, { courseId, bookId }) {
            context.commit("SET_LOADING_STATUS", true);
            try {
                await api.delete(`/v1/courses/${courseId}/books/${bookId}`);
                context.commit("REMOVE_COURSE_BOOK", bookId);
            } catch (error) {
                console.error("removeBookFromCourse:", error);
                throw error;
            } finally {
                context.commit("SET_LOADING_STATUS", false);
            }
        },

        async reorderCourseBooks(context, { courseId, books }) {
            context.commit("SET_LOADING_STATUS", true);
            try {
                const payload = {
                    books: books.map((book, index) => ({
                        cb_id: book.cb_id,
                        cb_order: index + 1
                    }))
                };

                await api.put(`/v1/courses/${courseId}/books/reorder`, payload);
                context.commit("UPDATE_COURSE_BOOKS_ORDER", books);
            } catch (error) {
                console.error("reorderCourseBooks:", error);
                throw error;
            } finally {
                context.commit("SET_LOADING_STATUS", false);
            }
        }
    },
};